document.addEventListener("DOMContentLoaded", function() {
    //menu fix
    var navElm = document.querySelector("main > nav");
    var mainRect = document.querySelector("main").getBoundingClientRect();
    var bodyRect = document.body.getBoundingClientRect();
    var offset = mainRect.top - bodyRect.top;

    window.addEventListener("scroll", function(e) {
        if ( window.innerWidth > 1024 ) {
            if (window.scrollY > offset) {
                navElm.classList.add("small");
                handleResize();
                window.addEventListener('resize', handleResize);
            } else {
                navElm.classList.remove("small");
                window.removeEventListener('resize', handleResize);
            }
        }
    });

    function handleResize() {
        var logoAside = document.querySelector("aside .logo");
        var logoNav = document.querySelector("main nav .logo");
        logoNav.style.left = logoAside.getBoundingClientRect().left + "px";
    }

    //responsive menu
    var menuElm = document.querySelector("#responsive-menu");
    menuElm.addEventListener("click", function(e) {
        menuElm.classList.toggle("open");
        document.body.classList.toggle("overflow-hidden");
    });

    //multiselect
    var multiSelectElm = document.querySelector(".multiselect");
    var multiSelectCheckboxesElm = document.querySelector(".multiselect #checkboxes");
    var multiSelectSelectElm = document.querySelector(".multiselect .select");
    multiSelectSelectElm &&
        multiSelectSelectElm.addEventListener("click", function() {
            multiSelectCheckboxesElm.classList.toggle("display-none");
            multiSelectElm.classList.toggle("open");
            window.addEventListener("click", function(e) {
                if (!multiSelectElm.contains(e.target))
                    multiSelectCheckboxesElm.classList.add("display-none");
            });
        });
});


$(document).ready(function(){

    $('#responsive-menu .has-submenu > a').on('click', function(e){
        e.preventDefault();
        e.stopPropagation();
        $(this).parent().toggleClass('open');
    });

    // autogrow
    $('textarea.autogrow').autogrow({
        animate: false
    });
    //

    // Internal bookmarks
    $(".bookmark").click(function(e) {
        if (location.pathname.replace(/^\//,'') == this.pathname.replace(/^\//,'') 
            || location.hostname == this.hostname) {
    
            var target = $(this.hash);
            target = target.length ? target : $('[name=' + this.hash.slice(1) +']');
               if (target.length) {
                 $('html,body').animate({
                     scrollTop: target.offset().top - 100
                }, 500);
                return false;
            }
        }
    });
    //

    // category filter
    $('.cat_filter').each(function(){
        $(this).on("change", function() {
            setFilters();
        });
    });

    var radius = $("#sel_distance") || "";
    var location = $("#txt_location") || "";

    radius.on("change", function() {
        setFilters();
    });

    location.on("keyup",  
        $.debounce(250, function(e) {
            setFilters();
        })
    );
    
    var setFilters = function() {
        var values = "";

        $('.cat_filter:checked').each(function(){
            values += $(this).val() + ",";
        });

        window.location.href =
            window.location.pathname +
            "?" +
            $.param({
                filter: values.slice(0, -1),
                location: location.val(),
                radius: radius.val()
            });
    };

    $('.filter_keyword').each(function() {
        $(this).on("click", function(e) {
            e.preventDefault();
            $('.cat_filter[value="' + this.rel + '"]').click();
        })
    })
    //

});

/*
 * jQuery throttle / debounce - v1.1 - 3/7/2010
 * http://benalman.com/projects/jquery-throttle-debounce-plugin/
 * 
 * Copyright (c) 2010 "Cowboy" Ben Alman
 * Dual licensed under the MIT and GPL licenses.
 * http://benalman.com/about/license/
 */
(function(b,c){var $=b.jQuery||b.Cowboy||(b.Cowboy={}),a;$.throttle=a=function(e,f,j,i){var h,d=0;if(typeof f!=="boolean"){i=j;j=f;f=c}function g(){var o=this,m=+new Date()-d,n=arguments;function l(){d=+new Date();j.apply(o,n)}function k(){h=c}if(i&&!h){l()}h&&clearTimeout(h);if(i===c&&m>e){l()}else{if(f!==true){h=setTimeout(i?k:l,i===c?e-m:e)}}}if($.guid){g.guid=j.guid=j.guid||$.guid++}return g};$.debounce=function(d,e,f){return f===c?a(d,e,false):a(d,f,e!==false)}})(this);